module.exports = __webpack_public_path__ + "img/about_us.b596ed1f.png";